import request from "superagent"

const completeSignup = (url, user, cb) => {
  return request.post(url).accept("json").send(user).end(cb)
}

export const getSponsorForSignup = (subdomain, cb) => {
  return request
    .get("/api4/direct/signup-v2?subdomain=" + subdomain)
    .accept("json")
    .end(cb)
}

export const completeDirectSignup = (user, cb) => completeSignup("/api4/direct/signup", user, cb)

export const completeStudentSignup = (user, cb) => completeSignup("/api4/student/signup", user, cb)

export const searchSchools = (zip, cb) => {
  return request
    .get("/api-signup/schools?zip=" + zip)
    .accept("json")
    .end(cb)
}

export const validateUniqueUsername = (username, cb) => {
  return request
    .get("/api/users/username/validate?username=" + encodeURIComponent(username))
    .accept("json")
    .end(cb)
}

export const getKlassByCode = (code, cb) => {
  return request
    .get("/api4/klass/" + code)
    .accept("json")
    .end(cb)
}
